import {
  SvgCompany,
  SvgFormUser,
  SvgKey,
  SvgEnvelop,
  SvgLocation,
} from "../../../../assets/icons";
import { WithIconTextareaFormInput } from "../withIconTextAreaFormInput";
import { ApiSchemaCountryList } from "../../../../models/api/apiCountryList";
import { useState, useEffect } from "react";
import { ApiCountryList } from "../../../../core/apis/countryList";
import { SelectPickerFormInput } from "../selectPickerFormInput.component";

export type IEditFormProps = {
  country: string;
};
export const EditForm = (props: IEditFormProps) => {
  const [countryList, setCountryList] = useState<ApiSchemaCountryList[]>();
  useEffect(() => {
    ApiCountryList.getCountryList().then((res) => {
      setCountryList(res.Data);
    });
  }, []);
  const countryDropdown =
    countryList?.map((item) => ({ label: item.Name, value: item.Id })) ?? [];
  return (
    <>
      <div className="d-flex flex-column px-3">
        <h6 className="mb-3 mt-1">Sign In Information</h6>
        <p className="fw-bold card-text ms-1">Email</p>
        <WithIconTextareaFormInput
          className=" m-0 w-100 disabled"
          placeholder="Please enter email"
          name="email"
          svgicon={SvgEnvelop}
        />
        <p className="fw-bold mt-3 card-text ms-1">User Name</p>
        <WithIconTextareaFormInput
          className=" m-0 w-100 disabled"
          name="userName"
          svgicon={SvgFormUser}
        />
        <p className="fw-bold mt-3 card-text ms-1">Password</p>
        <WithIconTextareaFormInput
          className=" m-0 w-100"
          name="password"
          type="password"
          svgicon={SvgKey}
        />
        <p className="mt-1 info-text ms-2 text-danger">
          {" "}
          If you change this password, this Account's password will be changed.
        </p>
        <p className="fw-bold mt-3 card-text ms-1">Confirm Password</p>
        <WithIconTextareaFormInput
          className=" m-0 w-100"
          placeholder="Please enter confirm password"
          name="confPassword"
          type="password"
          svgicon={SvgKey}
        />

        <h6 className="mb-3 mt-4">Basic Information</h6>
        <p className="fw-bold card-text ms-1">First Name</p>
        <WithIconTextareaFormInput
          className=" m-0 w-100"
          placeholder="Please enter firstname"
          name="firstName"
          svgicon={SvgFormUser}
        />
        <p className="fw-bold mt-3 card-text ms-1">Last Name</p>
        <WithIconTextareaFormInput
          className=" m-0 w-100"
          name="lastName"
          placeholder="Please enter lastname"
          svgicon={SvgFormUser}
        />
        <p className="fw-bold mt-3 card-text ms-1">Company Name</p>
        <WithIconTextareaFormInput
          className=" m-0 w-100"
          name="companyName"
          placeholder="Please enter company name"
          svgicon={SvgCompany}
        />
        <p className="fw-bold mt-3 card-text ms-1">Address</p>
        <WithIconTextareaFormInput
          className=" m-0 w-100"
          name="address"
          placeholder="Please enter address"
          svgicon={SvgLocation}
        />
        <p className="fw-bold mt-3 card-text ms-1">State</p>
        <WithIconTextareaFormInput
          className=" m-0 w-100"
          name="state"
          placeholder="Please enter state"
          svgicon={SvgLocation}
        />
        <p className="fw-bold mt-3 card-text ms-1">Country</p>
        <SelectPickerFormInput
          name="countryId"
          data={countryDropdown}
          value={props.country}
          placeholder="Select Country"
          size="sm"
          placement="topStart"
          block
        />
      </div>
    </>
  );
};
